import * as React from 'react';
import { Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, AlertMessage, AlertType, Form } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { ManageReferralApi } from '../../../../api/ManageReferralApi';
import { setMessage } from '../../../../helpers/MessageHelper';
import { REFERRAL, PATIENT } from '../../../../utils/RouteConstants';
import { useHistory } from 'react-router-dom';
import { IReferral } from '../../../../models/IReferral';

interface IReferralCloseModal {
    referralId: number;
    onSuccess: (copiedData: IReferral, successMessage: string) => void;
    patientGuidId: string;
}

export const ReferralCopyModal: React.FunctionComponent<IReferralCloseModal> = ({ referralId, onSuccess, patientGuidId }) => {

    const [errorMessage, setErrorMessage] = React.useState<string>();
    const auth = useAuth();
    const referralResponseApi = new ManageReferralApi(auth);
    const [isCopyingReferral, setIsCopyingReferral] = React.useState<boolean>(false);
    const history = useHistory();

    const copyReferral = () => {
        setIsCopyingReferral(true);
        referralResponseApi.copyReferral(referralId.toString(),
            (copiedData: IReferral) => {
                document.getElementById("close-referral-copy-modal")?.click();
                history.replace(`/${PATIENT}/${patientGuidId}/${REFERRAL}`, copiedData);
                onSuccess(copiedData, "Specialistremissen har kopierats");
            },
            (error: string) => {
                const newMessage = setMessage(error, errorMessage ?? "");
                setErrorMessage(newMessage);
            },
            () => {
                setIsCopyingReferral(false);
            })
    }

    return (
        <Modal header="Kopiera specialistremiss" modalSize={ModalSize.small} id="referral-copy-modal">
            <Form onSubmit={copyReferral}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                    <p>Är du säker på att du vill skapa upp en ny specialistremiss utifrån den aktuella remissen?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton id="close-referral-copy-modal" buttonType={ButtonType.general} buttonText="Stäng" data-dismiss="modal" />
                    <CustomSubmitButton isLoading={isCopyingReferral}>Kopiera specialistremiss</CustomSubmitButton>
                </ModalFooter>
            </Form>
        </Modal>
    )
}